"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeChipStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeChipStyles = function makeChipStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiChip: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread({}, tokens.typography["short-copy-small"]), {}, {
          fontWeight: primitives.fontWeights.stout,
          width: "fit-content",
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
          backgroundColor: tokens.colors["detail-1-40"].rgb,
          color: tokens.colors["ink-on-background"].rgb
        }, tokens.transitions["state-blur"]), {}, {
          "&:hover": _objectSpread({
            backgroundColor: tokens.colors["detail-1-40"].rgb
          }, tokens.transitions["enter"]),
          "&.DhigChip--selected": _objectSpread({
            backgroundColor: tokens.colors["detail-2-opaque"].rgb,
            color: tokens.colors["ink-on-fill-primary"].rgb
          }, tokens.transitions["state-activate"]),
          "&:has(svg:hover), &:has(svg:focus-visible)": _objectSpread({
            boxShadow: "none",
            backgroundColor: tokens.colors["detail-1-40"].rgb
          }, tokens.transitions["state-activate"]),
          '& [class*="MuiChip-avatar"]': {
            margin: "".concat(primitives.spacings[0], " ").concat(primitives.spacings["1"], " ").concat(primitives.spacings[0], " -").concat(primitives.spacings["2"]),
            height: primitives.spacings["6"],
            width: primitives.spacings["6"],
            color: tokens.colors["ink-on-background"].rgb
          },
          '& [class*="MuiChip-icon"]': {
            margin: "".concat(primitives.spacings[0], " ").concat(primitives.spacings["1"], " ").concat(primitives.spacings[0], " -").concat(primitives.spacings["1"]),
            fontSize: primitives.fontSizes["4"],
            color: tokens.colors["ink-on-background"].rgb,
            height: primitives.spacings["5"],
            width: primitives.spacings["5"]
          },
          '& [class*="MuiChip-deleteIcon"]': _objectSpread(_objectSpread({
            color: tokens.colors["ink-on-background"].rgb,
            fontSize: primitives.fontSizes["3"],
            outlineOffset: "1px",
            borderRadius: primitives.borderRadii.round,
            margin: "".concat(primitives.spacings[0], " -").concat(primitives.spacings["2"], " ").concat(primitives.spacings[0], " ").concat(primitives.spacings["1"]),
            display: "inline-block",
            position: "relative",
            zIndex: 1,
            padding: primitives.spacings["1"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover, &:focus:not(:focus-visible):hover": _objectSpread({
              color: tokens.colors["ink-on-background"].rgb,
              backgroundColor: tokens.colors["activated-fill-subtle"].rgb
            }, tokens.transitions["enter"]),
            "&:focus-visible": _objectSpread(_objectSpread({}, tokens.effects["focus-ring-reverse"]), {}, {
              outline: "none"
            }, tokens.transitions["state-activate"]),
            "&:focus:not(:focus-visible)": _objectSpread({
              boxShadow: "none",
              outline: "none"
            }, tokens.transitions["state-activate"]),
            "&:active, &:focus:not(:focus-visible):active": _objectSpread({
              backgroundColor: tokens.colors["activated-hover-fill-subtle"].rgb
            }, tokens.transitions["state-activate"]),
            tabIndex: 0
          })
        }),
        clickable: {
          "&:hover": _objectSpread(_objectSpread({}, tokens.effects["halo-hover"]), {}, {
            color: tokens.colors["ink-on-background"].rgb
          }),
          "&:focus-visible": _objectSpread(_objectSpread({}, tokens.effects["focus-ring-reverse"]), {}, {
            backgroundColor: tokens.colors["detail-1-40"].rgb
          }, tokens.transitions["state-activate"]),
          "&:active": _objectSpread({}, tokens.effects["halo-pressed"])
        },
        deletable: {
          "&:focus-visible": _objectSpread(_objectSpread({}, tokens.effects["focus-ring-reverse"]), {}, {
            backgroundColor: tokens.colors["detail-1-40"].rgb
          })
        },
        colorError: {
          backgroundColor: tokens.colors.background.rgb,
          color: tokens.colors["ink-error"].rgb,
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-error"].rgb),
          "&.DhigChip--selected": {
            backgroundColor: tokens.colors["fill-error"].rgb,
            color: tokens.colors["ink-on-fill-alert"].rgb
          }
        },
        label: {
          padding: primitives.spacings[0]
        }
      }
    }
  };
};

exports.makeChipStyles = makeChipStyles;